import { createApp } from "vue";
import VesselGroupBlock from "./app.vue";

function initVesselGroupBlock() {
  const appEls = document.querySelectorAll("vessel-groups-block");
  
  appEls.forEach(appEl => {
    // Check if Vue app is already mounted on this element
    if (appEl.__vue_app__) {
      return; // Skip if already mounted
    }
    
    // Parse props from data-props attribute
    let props = {};
    if (appEl.dataset.props) {
      try {
        const parsedProps = JSON.parse(appEl.dataset.props);
        props = parsedProps;
      } catch (e) {
        console.error("Error parsing vessel groups props:", e);
        console.error("Raw data-props content:", appEl.dataset.props);
        console.error("Data length:", appEl.dataset.props.length);
        
        // Try to identify the problematic character position
        if (e.message.includes('position')) {
          const match = e.message.match(/position (\d+)/);
          if (match) {
            const position = parseInt(match[1]);
            const start = Math.max(0, position - 50);
            const end = Math.min(appEl.dataset.props.length, position + 50);
            console.error("Context around error position:", appEl.dataset.props.substring(start, end));
            console.error("Character at error position:", appEl.dataset.props.charCodeAt(position));
          }
        }
        
        // Fallback: try to parse without problematic parts
        try {
          // Remove control characters and try again
          const cleanedData = appEl.dataset.props.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
          const parsedProps = JSON.parse(cleanedData);
          props = parsedProps;
          console.warn("Successfully parsed after removing control characters");
        } catch (secondError) {
          console.error("Failed to parse even after cleaning:", secondError);
        }
      }
    }
    
    // Create Vue app with props
    const app = createApp(VesselGroupBlock, {
      vesselGroupsArray: props.vessel_groups_array || []
    });
    
    app.mount(appEl);
    
    // Mark element as having a mounted Vue app
    appEl.__vue_app__ = app;
  });
}

// Try to initialize immediately
initVesselGroupBlock();

// Also try after DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVesselGroupBlock);
} else {
  // DOM is already loaded, try again in case element was added dynamically
  setTimeout(initVesselGroupBlock, 100);
}
